import React from 'react';
import { Modal } from 'semantic-ui-react';
import IconView from 'common/IconView';


const AppAbout = function(props) {
  return (
    <Modal className='about' open={props.visible} onClose={props.onClose}>
      <Modal.Header><IconView icon={88} />Black Skulls Editor</Modal.Header>
      <Modal.Content>
        <p>
          This editor is a basic tool for editing content for Black Skulls RPG
          released for Android. The packages from this editor will create
          appropriate files for you. Some extra meta data is saved to allow
          smooth editing which are not needed for a published adventure module.
        </p>
        <p>
          Editor was created and is maintained by TOJsoft.
        </p>
        <p>
          Most of the tiles have been drawn by David E. Gervais and are published
          under Creative Commons Attribution 3.0. Some modifications have been done
          to support transparency and provide some new icons (some from scratch).
          <ul>
            <li>
              <a href="http://creativecommons.org/licenses/by/3.0/" target="_blank" rel="noopener noreferrer">
                http://creativecommons.org/licenses/by/3.0/
              </a>
            </li>
            <li>
              <a href="http://pousse.rapiere.free.fr/tome/tome-tiles.htm" target="_blank" rel="noopener noreferrer">
                http://pousse.rapiere.free.fr/tome/tome-tiles.htm
              </a>&nbsp;(original tiles found here)
            </li>
          </ul>
        </p>
        <pre className='licenses'>
{` ===== Usage of React =====

MIT License

Copyright (c) Facebook, Inc. and its affiliates.

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.



 ===== Usage of Semantic-UI-React =====

MIT License

Copyright (c) 2016 TechnologyAdvice

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.



 ===== Usage of Redux =====

The MIT License (MIT)

Copyright (c) 2015-present Dan Abramov

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
        `}</pre>
      </Modal.Content>
    </Modal>
  );
}


export default AppAbout;
